import { GlIcon } from '@gitlab/ui';
import { n__, sprintf } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { LINKED_CATEGORIES_MAP, STATE_OPEN } from '../../constants';
import workItemLinkedItemsSlimQuery from '../../graphql/work_items_linked_items_slim.query.graphql';
import { findLinkedItemsWidget } from '../../utils';
import WorkItemRelationshipPopover from './work_item_relationship_popover.vue';
export default {
    name: 'WorkItemRelationshipIcons',
    components: {
        GlIcon,
        WorkItemRelationshipPopover
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        workItemType: {
            type: String,
            required: true
        },
        workItemWebUrl: {
            type: String,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: true
        },
        targetId: {
            type: String,
            required: false,
            default: ''
        },
        blockingCount: {
            type: Number,
            required: false,
            default: 0
        },
        blockedByCount: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data () {
        return {
            loadingItems: true,
            childItemLinkedItems: [],
            activePopoverType: null
        };
    },
    apollo: {
        childItemLinkedItems: {
            skip () {
                return this.loadingItems;
            },
            query () {
                return workItemLinkedItemsSlimQuery;
            },
            variables () {
                return {
                    fullPath: this.workItemFullPath,
                    iid: this.workItemIid,
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                };
            },
            update ({ namespace }) {
                if (!namespace?.workItem) return [];
                return findLinkedItemsWidget(namespace.workItem).linkedItems?.nodes || [];
            }
        }
    },
    computed: {
        itemsBlockedByIconId () {
            return `relationship-blocked-by-icon-${this.targetId || this.workItemIid}`;
        },
        itemsBlocksIconId () {
            return `relationship-blocks-icon-${this.targetId || this.workItemIid}`;
        },
        blockedByLabel () {
            const message = sprintf(n__('WorkItem|%{workItemType} is blocked by 1 item', 'WorkItem|%{workItemType} is blocked by %{itemCount} items', this.blockedByCount), {
                itemCount: this.blockedByCount
            });
            return sprintf(message, {
                workItemType: this.workItemType
            });
        },
        blocksLabel () {
            const message = sprintf(n__('WorkItem|%{workItemType} blocks 1 item', 'WorkItem|%{workItemType} blocks %{itemCount} items', this.blockingCount), {
                itemCount: this.blockingCount
            });
            return sprintf(message, {
                workItemType: this.workItemType
            });
        },
        blockedByItems () {
            return this.childItemLinkedItems.filter((item)=>item.linkType === LINKED_CATEGORIES_MAP.IS_BLOCKED_BY && item.workItem.state === STATE_OPEN);
        },
        blockingItems () {
            return this.childItemLinkedItems.filter((item)=>item.linkType === LINKED_CATEGORIES_MAP.BLOCKS && item.workItem.state === STATE_OPEN);
        }
    },
    methods: {
        handleBlockedByMouseEnter () {
            this.activePopoverType = 'blockedBy';
            this.loadingItems = false;
        },
        handleBlocksMouseEnter () {
            this.activePopoverType = 'blocks';
            this.loadingItems = false;
        }
    }
};
